export default __webpack_public_path__ + "static/media/Pitstone.11d47ebe.jpg";